<template>
  <div class="video-wrap" @click="handlePaly">
    <div class="course__imgCover">
      <img class="course__imgLayer" :src="video.videoImageUrl" />
      <img v-if="isCanPlay" class="course__tryTips" src="https://coolcdn.igetcool.com/p/2022/4/0559824e9d13d11cde29412f6624b76b.png?_64x36.png" />
      <div class="course__text">{{video.videoTimeLen}}</div>
    </div>

    <div class="course__videoMsg">
      <div class="course__videoName">{{video.videoTitle}}</div>
      <div class="course__videoDesc">
        <div class="course__videoStudyNum"> </div>
        <img v-if="!isCanPlay" src="https://coolcdn.igetcool.com/p/2022/4/15783388e3b8c7fb5cac4171dcbb1ac1.png?_48x48.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubsectionVideo',
  props: {
    video: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    };
  },
  computed: {
    // 是否可播放
    isCanPlay() {
      return this.video.free === 1;
    }
  },
  methods: {
    handlePaly() {
      this.$emit('onJump', { data: this.video, type: 2 });
    },
  }
};
</script>

<style lang="stylus" scoped>
.video-wrap {
  font-size: 12px;
  display: flex;
  padding: 10px 0 11px;
  .course__imgCover {
    width: 150px;
    height: 84px;
    position: relative;
    text-align: right;
    margin-right: 15px;
    .course__imgLayer {
      width: 150px;
      height: 100%;
      border-radius: 8px;
    }
    .course__tryTips {
      width: 32px;
      height: 18px;
      position: absolute;
      bottom: 8px;
      left: -4px;
    }
    .course__text {
      color: #fff;
      line-height: 17px;
      position: absolute;
      right: 4px;
      bottom: 2px;
    }
  }

  .course__videoMsg {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .course__videoName {
      color: #41414D;
      font-size: 16px;
      line-height: 20px;
    }

    .course__videoDesc {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .course__videoStudyNum {
        color: #6D6D80;
        line-height: 16px;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>